export class XpoDataDrawerState<T> {
  focusedRecord: T;
  selection?: T[];
}
